/**
 * Created by hernanherreros on 2019-05-27
 */

import * as React from 'react'
import styled from 'styled-components'
import LottieAnimation from '../../../components/Utils/LottieAnimation'
import animation from '../../../static/animations/not-found.json'
import { fontSize, FontSizeProps } from 'styled-system'
import { Trans } from '@lingui/macro'

interface Props {
  message?: string;
}

export default ({ message }: Props) => (
  <Container>
    <Wrapper>
      <LottieAnimation animation={animation} height={200}/>
      <Text fontSize={3}><Trans>No existe la inscripción</Trans></Text>
      {message && <Text fontSize={2}>{message}</Text>}
    </Wrapper>
  </Container>
)

const Container = styled.div`
  height: 100%;
  width: 500;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
`

const Wrapper = styled.div`
  max-width: 400px;
  width: 100%;
`
const Text = styled.h1<FontSizeProps>`
  font-weight: 400;
  color: #666;
  text-align: center;  
  
  ${fontSize}
 `